<div class="pdf-page app-aul-001-24" id="aul00124">
  <!-- <app-policy-header></app-policy-header> -->
  @if (isNewJerseyPolicy()) {
    <div style="margin-bottom: 10px; text-align: right;">
      <b>New Jersey Transaction Number {{ getNJTN() }}</b>
    </div>
  }
  <p class="font-large" style="text-align: center">
    <b>COMMERCIAL LINES POLICY</b>
  </p>
  <p class="font-large" style="text-align: center">
    <b>FORTEGRA SPECIALTY INSURANCE COMPANY</b>
  </p>
  <p class="font-large" style="text-align: center">
    <b>COMMON POLICY DECLARATIONS</b>
  </p>
  <p class="font-small">
    In return for the payment of the premium and fees, and subject to all the
    terms of this policy, we agree with You to provide the insurance as stated
    in this policy for the following coverage parts. This Common Policy
    Declarations, The Policy Jacket, Common Policy Conditions, Commercial
    Property Coverage Part Declarations and all Coverage Forms and Endorsements
    complete this Policy.
  </p>
  <br />
  <table style="width:100%; font-size: 16px;">
    <tbody>
      <tr>
          <td style="width: 100% !important;">
          <b
            > Named Insured: <span>{{ policyDetails?.nameInsured }}</span></b
          >
        </td>
      </tr>
  </tbody>
  </table>
   <table  style="width:100%; font-size: 14px;">
   <tbody>
      <tr> 
        <td style="width: 50% !important;">
          Mailing Address:
          <span
            >{{ policyDetails?.mailingAddresses[0]?.streetNum }},
            {{ policyDetails?.mailingAddresses[0]?.streetName }},
            {{
              policyDetails?.mailingAddresses[0]?.unitNum
                ? policyDetails?.mailingAddresses[0]?.unitNum + ","
                : ""
            }}
            {{ policyDetails?.mailingAddresses[0]?.city }},
            {{ policyDetails?.mailingAddresses[0]?.county }},
            {{ policyDetails?.mailingAddresses[0]?.state }},
            {{ policyDetails?.mailingAddresses[0]?.zipcode }}</span
          >
        </td>
        </tr>
        </tbody>
        </table>

          <table  style="width:100%; font-size: 14px;">
    <tbody>
      
      <tr>
        <td style="width: 50% !important;">
          Policy Number: <span>{{ policyDetails?.policyNo}}</span>
        </td>
        <td style="width: 50% !important;">
          Date Policy Issued:<span>{{
            policyDetails?.policyDate | date : "MM/dd/yyyy"
          }}</span>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <table style="width:100%; font-size: 14px;">
    <tbody>
      <tr>       
        <td style="width: 50% !important;">
          Policy Period: Inception Date:
          <span>{{ policyDetails?.inceptionDate | date : "MM/dd/yyyy" }}</span>
        </td>
        <td style="width: 50% !important;">
          Expiry Date:
          <span>{{ policyDetails?.expiryDate | date : "MM/dd/yyyy" }}</span>
        </td>
      </tr>
    </tbody>
  </table>
<table  style="width:100%; font-size: 14px;">
    <tbody>
      <tr>
         <td style="width: 100% !important;">
          At 12:01 AM Standard Time at Covered Premises Address
        </td>
      </tr>
    </tbody>
   </table>
  <hr />
  <table style="width:100%; font-size: 14px;">
    <tbody>
      <tr>
        <td style="width: 50% !important;">
          Surplus Lines Producer Name: {{ policyDetails?.agentName }}
        </td>
        <td style="width: 50% !important;">
          License#:
          <span>{{
            policyDetails?.slAgentAddresses[0]?.slAgentLicenseNumber
          }}</span>
        </td>
      </tr>
    </tbody>
  </table>
  <table style="width:100%; font-size: 14px;">
    <tbody>
      <tr>
        <td style="width: 50% !important;">
          Mailing Address:
          <span
            >{{ policyDetails?.slAgentAddresses[0]?.streetNum }},
            {{ policyDetails?.slAgentAddresses[0]?.streetName }},
            {{
              policyDetails?.slAgentAddresses[0]?.unitNum
                ? policyDetails?.slAgentAddresses[0]?.unitNum + ","
                : ""
            }}
            {{ policyDetails?.slAgentAddresses[0]?.city }},
            {{ policyDetails?.slAgentAddresses[0]?.county }},
            {{ policyDetails?.slAgentAddresses[0]?.state }},
            {{ policyDetails?.slAgentAddresses[0]?.zipcode }}</span
          >
        </td>
      </tr>
    </tbody>
  </table>
  <hr />
  <br />
  <table class="font-small" style="width: 100%">
    <tbody>
      <tr>
        <td style="width: 50%"><b>Coverage Part</b></td>
        <td style="width: 50%; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; white-space: nowrap; margin-right: auto;">
            <b>Premium</b>
          </span>
        </td>
      </tr>
      <tr>
        <td style="width: 50%">Commercial Property Coverage Part</td>
        <td style="width: 50%; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
            $
            {{
              policyDetails?.commericalPropCovPart
                | currency : "USD" : "" : "1.2-2"
            }}
          </span>
        </td>
      </tr>
      <tr>
        <td style="width: 50%">TRIA</td>
        <td style="width: 50%; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
            $ {{ policyDetails?.triaPremium | currency : "USD" : "" : "1.2-2" }}
          </span>
        </td>
      </tr>
      @if(policyDetails?.eqbdPremium !== 0){
      <tr>
        <td style="width: 50%">Equipment Breakdown</td>
        <td style="width: 50%; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
            $ {{ policyDetails?.eqbdPremium | currency : "USD" : "" : "1.2-2" }}
          </span>
        </td>
      </tr>
    }
      <tr>
        <td style="width: 50%">Inspection Fee</td>
        <td style="width: 50%; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
            $ {{ policyDetails?.inspectionFee | currency : "USD" : "" : "1.2-2" }}
          </span>
        </td>
      </tr>
      <tr
        *ngFor="let fee of policyDetails?.bislFeeDetails"
      >
        <td style="width: 50%">
          {{ fee?.otherDescription || fee?.slFeeDescription }}
        </td>
        <td style="width: 50%; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
            $
            {{ fee?.feeAmount | currency : "USD" : "" : "1.2-2" }}
          </span>
        </td>
      </tr>
      <tr>
        <td style="width: 50%"><b>Total Policy Premium</b></td>
        <td style="width: 50%; text-align: left;">
          <b>
            <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
              $
              {{
                (
                  (policyDetails?.triaPremium || 0) +
                  (policyDetails?.commericalPropCovPart || 0) +
                  (policyDetails?.eqbdPremium || 0) +
                  (policyDetails?.inspectionFee || 0) +
                  surplusFeeTotal
                )
                  | currency : "USD" : "" : "1.2-2"
              }}
            </span>
          </b>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <p class="font-small mb-2">
    The Total Policy Premium was computed based on rates in effect at the time
    the policy was issued. On each renewal, continuation, or anniversary of the
    effective date of this policy, we will compute the premium in accordance
    with our rates and rules then in effect.
  </p>
  
  <p class="font-small mb-2">
    Subject to any minimum earned endorsements listed within this policy, 25% of
    the Policy Premium is fully earned as of the effective date of this policy
    and is not subject to return or refund.
  </p>
  <p class="font-small mb-0">
    All Policy, Administration and/or Inspection Fees charged under this policy
    and/or identified on the Commercial Property Insurance Policy Jacket or in
    the Declarations Page are fully earned as of the policy inception date and
    are not refundable
  </p>
  <br />
  <p class="font-small mb-0">
    <b>
      {{ getSurplusLinesState() }} Surplus Lines Notice
      Attached
    </b>
  </p>
  <br />
  <p class="font-small mb-2">
    The Agent named in this policy is responsible for calculating and remitting
    any and all surplus lines taxes and fees that may apply to this policy.
  </p>
  <p class="font-small mb-2">
    The issuance of this insurance is facilitated by Alchemy Underwriting
    Limited (AUL) on behalf of Insurers identified within the policy and in
    accordance with the authorization granted to AUL and its affiliates. AUL is
    not an insurer under this policy and is not liable to indemnify the insured
    under the terms of this policy.
  </p>
</div>
